
class UnHandledRejectionException extends Error {
}

export default UnHandledRejectionException;